import { NgFor, NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { NgxPaginationModule, PaginatePipe } from 'ngx-pagination';
import { EncryptionService } from 'src/app/service/encryption.service';
import { ForumApiService } from 'src/app/service/forum.api.service';
import { StorageService } from 'src/app/service/storage.service';
import { APP_SETTINGS, AppSettings } from 'src/app/settings';
import { Meta } from '@angular/platform-browser';
import { GlobalValueService } from 'src/app/service/globalValue.service.';
import { LetsChatComponent } from "../lets-chat/lets-chat.component";
import { Title } from '@angular/platform-browser';
import { DataService } from 'src/app/service/data.service';
import { ConstantService } from 'src/app/service/constant.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-knowledge-base',
    standalone: true,
    templateUrl: './knowledge-base.component.html',
    styleUrls: ['./knowledge-base.component.less'],
    imports: [MatTabsModule, NgFor, NgIf, NgxPaginationModule, LetsChatComponent]
})


export class KnowledgeBaseComponent {
  
  faqArray = [];
  mainBaseArray = [];
  knowledgeBaseCategory = [];
  titleArrayForKeywords = [];

  baseState: any;

  p: number = 1;
  selected = 0;
  pageNumber: number = 1;
    
  categoryTitles: string;
  baseCategoryId: string;
  mainCategoryName: string;

  private routerSubscription: Subscription;
  private loadedFaqCategoryId: string;

  get activeCategory(): any {
    if (!this.mainCategoryName || !Array.isArray(this.mainBaseArray) || this.mainBaseArray.length === 0) {
      return null;
    }

    return this.mainBaseArray.find(category => category.permalink === this.mainCategoryName) ?? null;
  }

  constructor(
    @Inject(APP_SETTINGS) private settings: AppSettings,
    private encryptionService: EncryptionService,
    private forumApiService: ForumApiService,
    private storageService: StorageService,
    private router: Router,
    private meta: Meta,
    private globalValueService: GlobalValueService,
    private titleService: Title,
    private route: ActivatedRoute,
    private dataService: DataService,
    private constantService: ConstantService
  ) {}


  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      this.mainCategoryName = params.get('cname') || '';
      this.updateSelectedIndex();
    });

    this.backNavigation();

    this.dataService.data.subscribe((mainCategoryArray) => {
      if (!Array.isArray(mainCategoryArray) || mainCategoryArray.length === 0) {
        return;
      }

      this.knowledgeBaseCategory = mainCategoryArray;

      for(let i=0; i<this.knowledgeBaseCategory.length; i++) {
        this.mainBaseArray[i] = this.knowledgeBaseCategory[i];
        this.categoryTitles = this.categoryTitles==undefined?"":this.categoryTitles + " " + this.knowledgeBaseCategory[i].name;
        this.meta.updateTag({ name: this.constantService.description, content: this.categoryTitles});
        this.titleArrayForKeywords[i] = this.mainBaseArray[i].name;
      }
      var str = this.titleArrayForKeywords.join(", ");
      this.meta.updateTag({ name: this.constantService.keywords, content: str });
      this.updateSelectedIndex();
    });
    
    this.addMetaTag();
  }

  private updateSelectedIndex(): void {
    const category = this.activeCategory;
    if (!category) {
      return;
    }

    const selectedIndex = this.knowledgeBaseCategory.findIndex(
      element => element.permalink === this.mainCategoryName
    );

    if (selectedIndex >= 0) {
      this.selected = selectedIndex;
      this.baseCategoryId = category.id;
      this.titleService.setTitle(
        this.constantService.getKnowledgeBasePageTitle(category.name)
      );
    }

    if (category.child.length === 0 && this.loadedFaqCategoryId !== category.id) {
      this.loadedFaqCategoryId = category.id;
      this.frequentlyAskedQuestions(category.id);
    }
  }

  backNavigation() {
    try {
      this.routerSubscription = this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          if (event.navigationTrigger === 'popstate') {        
            this.dataService.data.subscribe((mainCategoryArray) => {
              if (!Array.isArray(mainCategoryArray) || mainCategoryArray.length === 0) {
                return;
              }

              mainCategoryArray.forEach((element, index) => {
                if(element.permalink == event.url.slice(1)){
                  this.selected = index;
                }
              });
            });
          }
        }
      });
    } catch (e) {
      console.log('Error in backNavigation method - ', e);
    }
  }

  addMetaTag(): void {
    this.meta.updateTag({ name: this.constantService.robots, content: this.constantService.forumPageRobotContent });
  }

  async knowledgeBase(): Promise<void> {
    try {
        for(let i=0; i<this.knowledgeBaseCategory.length; i++){
           this.mainBaseArray[i] = this.knowledgeBaseCategory[i];
           this.categoryTitles = this.categoryTitles==undefined?"":this.categoryTitles + " " + this.knowledgeBaseCategory[i].name;
           this.meta.updateTag({ name: this.constantService.description, content: this.categoryTitles});
           this.titleArrayForKeywords[i] = this.mainBaseArray[i].name;
        }
      var str = this.titleArrayForKeywords.join(", ");
      this.meta.updateTag({ name: this.constantService.keywords, content: str });     
    } catch (e) {
      console.group('Error Occured in knowledgeBase : ', e);
    }
  }  

  async frequentlyAskedQuestions(id): Promise<void> {
    try {
      this.faqArray = [];
      const portalId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.portalId));
      const categoryId = id;
      const from = this.constantService.faqRequestConstant.faqFrom;
      const limit = this.constantService.faqRequestConstant.faqLimitMax;
      const sortBy = this.constantService.faqRequestConstant.faqSortByLike;
      const locale = this.constantService.faqRequestConstant.faqlocale;
    
      await this.forumApiService.frequentlyAskedQuestions(portalId, categoryId, from, limit, sortBy, locale).then(async (faqResponse) => {
        for(let i=0; i<faqResponse.data.length; i++){
          this.faqArray[i] = faqResponse.data[i];         
        }
      });
    } catch (e) {
      console.group('Error Occured in frequentlyAskedQuestions : ', e);
    }    
  }

  clearPagination(tabEvent): void {
    this.p = 1;
    this.pageNumber = 1;
    this.selected = tabEvent.index;

    const category = this.mainBaseArray[tabEvent.index];
    if (!category) {
      return;
    }

    this.router.navigateByUrl(category.permalink);
  }

  setValues(value1: string, value2: string) : void {
    try{
      this.globalValueService.mainCategory = value1;
      this.globalValueService.subCategory = value2;
    } catch (e){
      console.log('Error in setValues method - ',e);
    }    
  }

  goToSubCategory(subId: string, subCategoryName: string): void{
   try{
    if(localStorage.getItem(this.constantService.isLoggedIn) == this.constantService.yes){
      this.setValues(this.baseCategoryId, subId);
    }
    this.router.navigateByUrl(this.mainCategoryName + '/' + subCategoryName);
   } catch(e){
    console.log('Error in goToSubCategory - ',e);
   }    
  }

  goTosubCategoryAnswers(questionId: string, subCategoryName: string, questionTitle: string): void {
    try{
      const sanitizedQuestionTitle = questionTitle.replace(/\//g, 'Or');
      this.router.navigate([this.mainCategoryName + '/' + subCategoryName + '/' + sanitizedQuestionTitle], {queryParams: { questionId }});
    } catch(e){
      console.log('Error in goTosubCategoryAnswers method - ',e);
    }
  }

  onSubCategoryKeydown(event: KeyboardEvent, index: number): void {
    this.moveListFocus(event, index, 'kb-subcategory-item');
  }

  onFaqItemKeydown(event: KeyboardEvent, index: number): void {
    this.moveListFocus(event, index, 'kb-faq-item');
  }

  private moveListFocus(event: KeyboardEvent, index: number, idPrefix: string): void {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      document.getElementById(`${idPrefix}-${index + 1}`)?.focus();
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      document.getElementById(`${idPrefix}-${index - 1}`)?.focus();
    }
  }
}